/* NOTE23 Anker – Gravur-Vorschau (Produktseite + Warenkorb) */
(function () {
  if (window.N23P) return;
  var BOXES = window.N23P_BOXES || {};
  var IMGS = window.N23P_IMG || {};
  var cache = {};

  function loadImg(n) {
    if (cache[n]) return cache[n];
    cache[n] = new Promise(function (res, rej) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); };
      im.onerror = function () { if (!im.__n23r) { im.__n23r = 1; var s0 = im.src; im.src = s0 + (s0.indexOf('?') > -1 ? '&' : '?') + 'n23r=' + Date.now(); } else { delete cache[n]; rej(new Error('n23 img')); } };
      im.src = IMGS[n];
    });
    return cache[n];
  }

  function fontFamily(font) {
    var f = String(font || '').toLowerCase();
    return (f === 'modern') ? "'Didact Gothic','Century Gothic',Arial,sans-serif"
                            : "'Old Standard TT',Georgia,'Times New Roman',serif";
  }

  function fontsReady(font) {
    try {
      if (!document.fonts) return Promise.resolve();
      var fam = (String(font||'').toLowerCase()==='modern') ? '400 20px "Didact Gothic"' : '700 20px "Old Standard TT"';
      return Promise.race([document.fonts.load(fam), new Promise(function(r){ setTimeout(r, 1500); })]);
    } catch (e) { return Promise.resolve(); }
  }

  function n23order(bx) {
    var L = [], R = [];
    bx.forEach(function (b, i) { var c = (b[0] + b[2]) / 2; (c < 0.5 ? L : R).push({ i: i, c: c }); });
    L.sort(function (a, b) { return b.c - a.c; }); R.sort(function (a, b) { return a.c - b.c; });
    var o = [];
    while (L.length || R.length) { if (L.length) o.push(L.shift().i); if (R.length) o.push(R.shift().i); }
    return o;
  }
  function n23inOrder(t, names) {
    var pos = -1;
    for (var i = 0; i < names.length; i++) { var k = t.indexOf(String(names[i]).toUpperCase(), pos + 1); if (k < 0) return false; pos = k; }
    return true;
  }
  function draw(canvas, names, font, opts) {
    opts = opts || {};
    var n = Math.max(1, Math.min(8, names.length || 1));
    if (!IMGS[n] || !BOXES[n]) return Promise.resolve(false);
    return Promise.all([loadImg(n), fontsReady(font)]).then(function (r) {
      var im = r[0];
      var W = im.naturalWidth, H = im.naturalHeight;
      var outW = opts.width || 1200;
      var scale = outW / W;
      canvas.width = Math.round(W * scale);
      canvas.height = Math.round(H * scale);
      var ctx = canvas.getContext('2d');
      ctx.drawImage(im, 0, 0, canvas.width, canvas.height);
      var fam = fontFamily(font);
      var bold = (String(font || '').toLowerCase() === 'modern') ? '400' : '700';
      var ORD = n23order(BOXES[n]);
      var UNI = Infinity;
      ORD.forEach(function (bi, i) {
        var b = BOXES[n][bi];
        var t = (names[i] || '').toString().toUpperCase();
        if (!t && opts.placeholders) t = (opts.placeholders[i] || '').toUpperCase();
        if (!t) return;
        var bw = (b[2] - b[0]) * canvas.width, bh = (b[3] - b[1]) * canvas.height;
        var base = bw * (bold === '400' ? 0.70 : 0.52), ml = bh;
        ctx.font = bold + ' ' + base + 'px ' + fam;
        var w = ctx.measureText(t).width;
        var s = base; var cf = (bold === '400' ? 0.62 : 0.70); if (w * cf > ml) s = base * ml / (w * cf);
        if (s < UNI) UNI = s;
      });
      ORD.forEach(function (bi, i) {
        var b = BOXES[n][bi];
        var raw = (names[i] || '').toString().toUpperCase();
        var ghost = false;
        if (!raw && opts.placeholders) { raw = (opts.placeholders[i] || '').toUpperCase(); ghost = true; }
        if (!raw) return;
        var x0 = b[0] * canvas.width, y0 = b[1] * canvas.height;
        var x1 = b[2] * canvas.width, y1 = b[3] * canvas.height;
        var bw = x1 - x0, bh = y1 - y0;
        var cx = x0 + bw / 2, cy = y0 + bh / 2;
        var base = bw * (bold === '400' ? 0.70 : 0.52), size = base, sx = 1;
        ctx.font = bold + ' ' + size + 'px ' + fam;
        var m = ctx.measureText(raw);
        var maxLen = bh;
        if (m.width > maxLen) {
          size = Math.max(base * 0.86, base * maxLen / m.width); ctx.font = bold + ' ' + size + 'px ' + fam; m = ctx.measureText(raw);
          if (m.width > maxLen) { sx = Math.max((bold === '400' ? 0.62 : 0.70), maxLen / m.width); if (m.width * sx > maxLen) { size = size * maxLen / (m.width * sx); ctx.font = bold + ' ' + size + 'px ' + fam; m = ctx.measureText(raw); } }
        }
        if (UNI < Infinity) { size = UNI; ctx.font = bold + ' ' + size + 'px ' + fam; m = ctx.measureText(raw); sx = m.width > maxLen ? maxLen / m.width : 1; }
        var bl = m.actualBoundingBoxLeft || 0, br = m.actualBoundingBoxRight || m.width, ba = m.actualBoundingBoxAscent || size * 0.7, bd = m.actualBoundingBoxDescent || 0;
        var tr = 0, nch = raw.length;
        if (sx === 1 && nch > 1) { tr = Math.max(0, Math.min(size * (bold === '400' ? 0.06 : 0.05) * Math.max(0, Math.min(1, (9 - nch) / 5)), (maxLen * 0.72 - m.width) / (nch - 1))); }
        var ox = (bl - br) / 2 - tr * (nch - 1) / 2, oy = (ba - bd) / 2;
        var fillT = function (dy) { if (!tr) { ctx.fillText(raw, ox, oy + dy); return; } for (var k = 0; k < nch; k++) { ctx.fillText(raw.charAt(k), ox + ctx.measureText(raw.slice(0, k)).width + tr * k, oy + dy); } };
        ctx.save();
        ctx.translate(cx, cy);
        ctx.rotate((b[4] || 0) * Math.PI / 180);
        ctx.rotate(-Math.PI / 2);
        ctx.scale(sx, 1);
        ctx.textAlign = 'left';
        ctx.textBaseline = 'alphabetic';
        ctx.globalAlpha = ghost ? 0.32 : 1;
        ctx.fillStyle = 'rgba(0,0,0,0.6)';
        fillT(Math.max(1, size * 0.05));
        var g = ctx.createLinearGradient(0, -size / 2, 0, size / 2);
        g.addColorStop(0, '#f4f4f4'); g.addColorStop(0.55, '#d2d2d2'); g.addColorStop(1, '#aaaaaa');
        ctx.fillStyle = g;
        fillT(0);
        ctx.restore();
      });
      return true;
    });
  }

  window.N23P = { draw: draw };
  document.dispatchEvent(new CustomEvent('n23p:ready'));

  /* ---------- Warenkorb (Section Store Cart-Drawer, Shadow DOM) ---------- */
  var EN = (document.documentElement.lang || '').indexOf('en') === 0;
  var N23LOC = String((window.Shopify && Shopify.locale) || document.documentElement.lang || 'de').toLowerCase().slice(0,2);
  var LBL = { en: 'Your engraving', sv: 'Din gravyr', fi: 'Kaiverruksesi' }[N23LOC] || 'Deine Gravur';
  var EDL = { en: 'Edit engraving', sv: 'Ändra gravyr', fi: 'Muokkaa kaiverrusta' }[N23LOC] || 'Gravur bearbeiten';
  var CHK = { en: 'We check every engraving before production', sv: 'Vi kontrollerar varje gravyr före tillverkning', fi: 'Tarkistamme jokaisen kaiverruksen ennen valmistusta' }[N23LOC] || 'Wir prüfen jede Gravur vor der Fertigung';
  var busy = false, again = false;
  var N23C = {};
  try { N23C = JSON.parse(sessionStorage.getItem('n23pc24') || '{}') || {}; } catch (e) { N23C = {}; }
  function saveC() {
    try {
      var ks = Object.keys(N23C).sort(function (a, b) { return (N23C[b].t || 0) - (N23C[a].t || 0); });
      ks.slice(6).forEach(function (k) { delete N23C[k]; });
      sessionStorage.setItem('n23pc24', JSON.stringify(N23C));
    } catch (e) {}
  }
  var CROPY = { 1: [0.12, 0.88], 2: [0.12, 0.88], 3: [0.12, 0.88], 4: [0.12, 0.88], 5: [0.12, 0.88], 6: [0.12, 0.88], 7: [0.12, 0.88], 8: [0.12, 0.88] };
  function n23crop(c, n) {
    var r = CROPY[n]; if (!r) return c;
    var y0 = Math.round(c.height * r[0]), h = Math.round(c.height * (r[1] - r[0]));
    var o = document.createElement('canvas'); o.width = c.width; o.height = h;
    o.getContext('2d').drawImage(c, 0, y0, c.width, h, 0, 0, c.width, h);
    return o;
  }
  function putBox(line, key, url, eu) {
    line.setAttribute('data-n23p', key);
    var old = line.querySelector('.n23p-cart');
    if (old) old.remove();
    var box = document.createElement('div');
    box.className = 'n23p-cart'; box.setAttribute('data-for', line.getAttribute('data-line-key') || '');
    box.setAttribute('style', 'flex:0 0 100%;grid-column:1/-1;width:100%;margin:6px 0 0;');
    box.innerHTML = '<div style="display:flex;align-items:center;gap:6px;flex-wrap:wrap;font-size:12px;line-height:1.4;margin:2px 0 0"><span style="color:#121212;font-weight:700">&#10003;</span><span style="opacity:.75">' + CHK + '</span><a class="n23p-edit" href="' + String(eu || '').replace(/"/g, '&quot;') + '" style="margin-left:auto;font-size:11.5px;opacity:.55;color:inherit;text-decoration:underline;text-underline-offset:2px;white-space:nowrap">' + EDL + '</a></div>';
    line.appendChild(box);
  }
  function lineKey(l) { return l.getAttribute('data-line-key') || ''; }
  function cleanLine(l) {
    var bx = l.querySelector('.n23p-cart');
    if (bx && bx.getAttribute('data-for') !== lineKey(l)) { bx.remove(); l.removeAttribute('data-n23p'); }
  }
  function applyCached() {
    cartRoots().forEach(function (r) {
      r.querySelectorAll('.cart-line-item').forEach(function (l) {
        cleanLine(l);
        var e = N23C[lineKey(l)];
        if (e && !l.querySelector('.n23p-cart')) putBox(l, e.key, e.url, e.eu);
      });
    });
  }


  function propNames(p) {
    var arr = [];
    for (var i = 1; i <= 8; i++) { var nv = (p['Name ' + i] != null && p['Name ' + i] !== '') ? p['Name ' + i] : p['Namn ' + i]; if (nv != null && nv !== '') arr.push(String(nv)); }
    return arr;
  }
  function cartRoots() {
    var roots = [];
    document.querySelectorAll('section-store--cart-block').forEach(function (h) { if (h.shadowRoot) roots.push(h.shadowRoot); });
    roots.push(document);
    return roots;
  }
  function decorate() {
    if (busy) { again = true; return; }
    var lines = [];
    cartRoots().forEach(function (r) { r.querySelectorAll('.cart-line-item').forEach(function (l) { lines.push(l); }); });
    if (!lines.length) return;
    busy = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var jobs = []; var used = []; var valid = {};
        cart.items.forEach(function (it) {
          var p = it.properties || {};
          var names = propNames(p);
          if (!names.length) return;
          var isK = /halskette/i.test(it.handle || '');
          if (!isK && !/anker/i.test(it.handle || '')) return;
          var font = p['Schriftart'] || p['Font'] || p['Typsnitt'] || 'Klassisch';
          var key = it.key + '#' + names.join('|') + '#' + font;
          valid[it.key] = 1;
          var line = lines.filter(function (l) { return lineKey(l) === it.key; })[0];
          if (!line) return; used.push(line); if (line.getAttribute('data-n23p') === key) return;
          var f = /modern/i.test(font) ? 'modern' : 'klassisch';
          var eu = String(it.url || ''); eu = (eu.charAt(0) === '/' && (root === '/' || eu.indexOf(root) === 0)) ? eu : root + eu.replace(/^\//, ''); eu += (eu.indexOf('?') === -1 ? '?' : '&') + 'n23e=' + encodeURIComponent(names.join('|')) + '&n23f=' + f + '&n23k=' + encodeURIComponent(it.key);
          var c = document.createElement('canvas');
          jobs.push((isK && window.N23K ? window.N23K.draw(c, names, f, window.N23K.colorOf(it), { width: 800 }) : draw(c, names, f, { width: 800 })).then(function (ok) {
            if (!ok) return;
            var url = (isK ? c : n23crop(c, names.length)).toDataURL('image/jpeg', 0.85);
            N23C[it.key] = { key: key, url: url, eu: eu, t: Date.now() }; saveC();
            putBox(line, key, url, eu);
          }));
        });
        lines.forEach(function (l) { cleanLine(l); if (!valid[lineKey(l)]) { var bx = l.querySelector('.n23p-cart'); if (bx) bx.remove(); l.removeAttribute('data-n23p'); } });
        return Promise.all(jobs);
      })
      .catch(function () {})
      .then(function () { busy = false; if (again) { again = false; setTimeout(decorate, 50); } });
  }
  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(decorate, 150); }
  var observed = new WeakSet();
  function observe(root) {
    if (!root || observed.has(root)) return;
    observed.add(root);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var tgt = muts[i].target;
        if (tgt && tgt.closest && tgt.closest('.n23p-cart')) continue;
        var added = muts[i].addedNodes;
        if (added && added.length === 1 && added[0].className === 'n23p-cart') continue;
        applyCached(); schedule(); return;
      }
    }).observe(root, { childList: true, subtree: true });
  }
  function hook() {
    document.querySelectorAll('section-store--cart-block').forEach(function (h) { if (h.shadowRoot) observe(h.shadowRoot); });
  }
  hook();
  new MutationObserver(hook).observe(document.body || document.documentElement, { childList: true });
  setInterval(hook, 2000);
  schedule();
})();

/* ---------- NOTE23 Halskette: Live-Vorschau je Farbe & Anzahl ---------- */
(function () {
  if (window.N23K) return;
  var CROP = [520, 1230, 1005, 495];
  var BOX = {
    1: [[1022, 1546, 123, 230, 0]],
    2: [[935, 1537, 123, 230, 8.9], [1109, 1537, 123, 230, -8.9]],
    3: [[852, 1512, 123, 230, 16.9], [1022, 1546, 123, 230, 0], [1192, 1512, 123, 230, -16.9]],
    4: [[777, 1475, 123, 230, 23.3], [935, 1537, 123, 230, 8.9], [1109, 1537, 123, 230, -8.9], [1267, 1475, 123, 230, -23.3]],
    5: [[709, 1430, 123, 230, 28.3], [852, 1512, 123, 230, 16.9], [1022, 1546, 123, 230, 0], [1192, 1512, 123, 230, -16.9], [1335, 1430, 123, 230, -28.3]]
  };
  var INK = {
    silber: { hi: 'rgba(255,255,255,0.45)', fg: ['#4a4a4a', '#2c2c2c'] },
    gold: { hi: 'rgba(255,238,200,0.45)', fg: ['#6b4e1c', '#3e2c0f'] },
    schwarz: { hi: 'rgba(0,0,0,0.55)', fg: ['#ececec', '#a9a9a9'] }
  };
  var cache = {};
  function colorKey(c) {
    c = String(c || '').toLowerCase();
    if (/schwarz|black/.test(c)) return 'schwarz';
    if (/gold/.test(c)) return 'gold';
    return 'silber';
  }
  function src(col, n) {
    return '/cdn/shop/files/n23ks2-' + col + '.jpg?crop=region&crop_left=0&crop_top=' + ((n - 1) * CROP[3]) + '&crop_width=' + CROP[2] + '&crop_height=' + CROP[3] + '&width=' + CROP[2];
  }
  function load(col, n) {
    var k = col + n;
    if (!cache[k]) cache[k] = new Promise(function (res, rej) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = function () { if (!im.__n23r) { im.__n23r = 1; var s0 = im.src; im.src = s0 + (s0.indexOf('?') > -1 ? '&' : '?') + 'n23r=' + Date.now(); } else { delete cache[k]; rej(new Error('n23 img')); } }; im.src = src(col, n); });
    return cache[k];
  }
  function fam(font) {
    return String(font || '').toLowerCase() === 'modern' ? "'Didact Gothic','Century Gothic',Arial,sans-serif" : "'Old Standard TT',Georgia,'Times New Roman',serif";
  }
  function fontsReady(font) {
    try {
      if (!document.fonts) return Promise.resolve();
      var f = String(font || '').toLowerCase() === 'modern' ? '400 20px "Didact Gothic"' : '700 20px "Old Standard TT"';
      return Promise.race([document.fonts.load(f), new Promise(function (r) { setTimeout(r, 1500); })]);
    } catch (e) { return Promise.resolve(); }
  }
  function colorOf(it) {
    var o = (it && it.options_with_values) || [];
    for (var i = 0; i < o.length; i++) if (/farbe|colou?r/i.test(o[i].name)) return o[i].value;
    return (it && it.variant_title) || '';
  }
  function draw(canvas, names, font, color, opts) {
    opts = opts || {};
    var n = Math.max(1, Math.min(5, names.length || 1));
    var col = colorKey(color), ink = INK[col];
    return Promise.all([load(col, n), fontsReady(font)]).then(function (r) {
      var im = r[0], outW = opts.width || 1100, s = outW / CROP[2];
      canvas.width = Math.round(CROP[2] * s);
      canvas.height = Math.round(CROP[3] * s);
      var ctx = canvas.getContext('2d');
      ctx.drawImage(im, 0, 0, canvas.width, canvas.height);
      var bold = String(font || '').toLowerCase() === 'modern' ? '400' : '700';
      var UNI = Infinity;
      BOX[n].forEach(function (b, i) {
        var t = String(names[i] || '').toUpperCase();
        if (!t && opts.placeholders) t = String(opts.placeholders[i] || '').toUpperCase();
        if (!t) return;
        var base = b[2] * s * (bold === '400' ? 0.54 : 0.46), ml = b[3] * s * 0.84;
        ctx.font = bold + ' ' + base + 'px ' + fam(font);
        var tw0 = ctx.measureText('CHRISTOPHER').width, s0 = base;
        var kc = (bold === '400' ? 0.56 : 0.62); if (tw0 * kc > ml) s0 = base * ml / (tw0 * kc);
        if (s0 < UNI) UNI = s0;
      });
      BOX[n].forEach(function (b, i) {
        var raw = String(names[i] || '').toUpperCase(), ghost = false;
        if (!raw && opts.placeholders) { raw = String(opts.placeholders[i] || '').toUpperCase(); ghost = true; }
        if (!raw) return;
        var cx = (b[0] - CROP[0]) * s, cy = (b[1] - CROP[1]) * s, w = b[2] * s, h = b[3] * s;
        var size = UNI < Infinity ? UNI : w * 0.36, max = h * 0.84, sx = 1;
        ctx.font = bold + ' ' + size + 'px ' + fam(font);
        var m = ctx.measureText(raw), tw = m.width;
        if (tw > max) { sx = Math.max(0.6, max / tw); if (tw * sx > max) { size = size * max / (tw * sx); ctx.font = bold + ' ' + size + 'px ' + fam(font); m = ctx.measureText(raw); tw = m.width; } }
        var tr = 0, nch = raw.length;
        if (sx === 1 && nch > 1) tr = Math.max(0, Math.min(size * (bold === '400' ? 0.06 : 0.05) * Math.max(0, Math.min(1, (9 - nch) / 5)), (max * 0.72 - tw) / (nch - 1)));
        var bl = m.actualBoundingBoxLeft || 0, br = m.actualBoundingBoxRight || tw, ba = m.actualBoundingBoxAscent || size * 0.7, bd = m.actualBoundingBoxDescent || 0;
        var ox = (bl - br) / 2 - tr * (nch - 1) / 2, oy = (ba - bd) / 2;
        var fillT = function (dy) { if (!tr) { ctx.fillText(raw, ox, oy + dy); return; } for (var k = 0; k < nch; k++) ctx.fillText(raw.charAt(k), ox + ctx.measureText(raw.slice(0, k)).width + tr * k, oy + dy); };
        ctx.save();
        ctx.translate(cx, cy);
        ctx.rotate(b[4] * Math.PI / 180);
        ctx.rotate(-Math.PI / 2);
        ctx.scale(sx, 1);
        ctx.textAlign = 'left';
        ctx.textBaseline = 'alphabetic';
        ctx.globalAlpha = ghost ? 0.32 : 1;
        ctx.fillStyle = ink.hi;
        fillT(Math.max(1, size * 0.04));
        var g = ctx.createLinearGradient(0, -size / 2, 0, size / 2);
        g.addColorStop(0, ink.fg[0]); g.addColorStop(1, ink.fg[1]);
        ctx.fillStyle = g;
        fillT(0);
        ctx.restore();
      });
      return true;
    }).catch(function () { return false; });
  }
  window.N23K = { draw: draw, colorOf: colorOf, colorKey: colorKey };
  document.dispatchEvent(new CustomEvent('n23p:ready'));
})();

/* ---------- NOTE23 Warenkorb-Übersetzung (Section Store Cart) ---------- */
(function () {
  if (window.__n23cartTr) return; window.__n23cartTr = true;
  var L = String((window.Shopify && Shopify.locale) || document.documentElement.lang || 'de').toLowerCase().slice(0, 2);
  var D = {
    en: { 'Gravur:': 'Engraving:', 'Schwarz': 'Black', 'Weiß': 'White', 'Warenkorb': 'Cart', 'Dein Warenkorb ist leer': 'Your cart is empty', 'Es sieht so aus, als hätten Sie noch nichts in Ihren Warenkorb gelegt.': "Looks like you haven't added anything to your cart yet.", 'Hinzufügen': 'Add', '+Hinzufügen': '+Add', 'INKL. KOSTENLOSER VERSAND': 'INCL. FREE SHIPPING', 'KOSTENLOSER VERSAND': 'FREE SHIPPING', 'GESAMTSUMME:': 'TOTAL:', 'SICHERE BEZAHLUNG': 'SECURE PAYMENT', 'ÜBER 12.000 ZUFRIEDENE KUNDEN': 'OVER 12,000 HAPPY CUSTOMERS', 'Schriftart:': 'Font:', 'Klassisch': 'Classic', 'Deine Gravur': 'Your engraving', 'oder weiter einkaufen': 'or continue shopping', 'Weiter einkaufen': 'Continue shopping' },
    sv: { 'Cart': 'Varukorg', 'Warenkorb': 'Varukorg', 'Dein Warenkorb ist leer': 'Din varukorg är tom', 'Your cart is empty': 'Din varukorg är tom', 'Es sieht so aus, als hätten Sie noch nichts in Ihren Warenkorb gelegt.': 'Det ser ut som att du inte har lagt något i varukorgen än.', 'You might like': 'Du kanske också gillar', 'Hinzufügen': 'Lägg till', '+Hinzufügen': '+Lägg till', 'INKL. KOSTENLOSER VERSAND': 'INKL. FRI FRAKT', 'KOSTENLOSER VERSAND': 'FRI FRAKT', 'GESAMTSUMME:': 'TOTALT:', 'SICHERE BEZAHLUNG': 'SÄKER BETALNING', 'ÜBER 12.000 ZUFRIEDENE KUNDEN': 'ÖVER 12 000 NÖJDA KUNDER', 'Schriftart:': 'Typsnitt:', 'Font:': 'Typsnitt:', 'Gravur:': 'Gravyr:', 'Engraving:': 'Gravyr:', 'Schwarz': 'Svart', 'Weiß': 'Vit', 'Klassisch': 'Klassisk', 'Classic': 'Klassisk', 'Deine Gravur': 'Din gravyr', 'Your engraving': 'Din gravyr', 'oder weiter einkaufen': 'eller fortsätt handla', 'Weiter einkaufen': 'Fortsätt handla' },
    fi: { 'Cart': 'Ostoskori', 'Warenkorb': 'Ostoskori', 'Dein Warenkorb ist leer': 'Ostoskorisi on tyhjä', 'Your cart is empty': 'Ostoskorisi on tyhjä', 'Es sieht so aus, als hätten Sie noch nichts in Ihren Warenkorb gelegt.': 'Et ole vielä lisännyt mitään ostoskoriin.', 'You might like': 'Saatat pitää myös näistä', 'Hinzufügen': 'Lisää', '+Hinzufügen': '+Lisää', 'INKL. KOSTENLOSER VERSAND': 'SIS. ILMAISEN TOIMITUKSEN', 'KOSTENLOSER VERSAND': 'ILMAINEN TOIMITUS', 'GESAMTSUMME:': 'YHTEENSÄ:', 'SICHERE BEZAHLUNG': 'TURVALLINEN MAKSU', 'ÜBER 12.000 ZUFRIEDENE KUNDEN': 'YLI 12 000 TYYTYVÄISTÄ ASIAKASTA', 'Schriftart:': 'Fontti:', 'Font:': 'Fontti:', 'Gravur:': 'Kaiverrus:', 'Engraving:': 'Kaiverrus:', 'Schwarz': 'Musta', 'Weiß': 'Valkoinen', 'Klassisch': 'Klassinen', 'Classic': 'Klassinen', 'Modern': 'Moderni', 'Deine Gravur': 'Kaiverruksesi', 'Your engraving': 'Kaiverruksesi', 'oder weiter einkaufen': 'tai jatka ostoksia', 'Weiter einkaufen': 'Jatka ostoksia' }
  }[L];
  
  var RX = {
    en: [[/^(?:\uD83D\uDD25\s*)?Spare jetzt bis zu\s*(\d+)\s*%/, 'Save up to 34% now'], [/^SICHER ZUR KASSE/, 'SECURE CHECKOUT'], [/^Name (\d):$/, 'Name $1:']],
    sv: [[/^(?:\uD83D\uDD25\s*)?Spare jetzt bis zu\s*(\d+)\s*%/, 'Spara upp till 34 % nu'], [/^SICHER ZUR KASSE/, 'SÄKER KASSA'], [/^Name (\d):$/, 'Namn $1:']],
    fi: [[/^(?:\uD83D\uDD25\s*)?Spare jetzt bis zu\s*(\d+)\s*%/, 'Säästä nyt jopa 34 %'], [/^SICHER ZUR KASSE/, 'TURVALLINEN KASSA'], [/^Name (\d):$/, 'Nimi $1:']]
  }[L];
  var HD = { en: 'Cart', sv: 'Varukorg', fi: 'Ostoskori' }[L] || 'Warenkorb';
  D = D || {}; RX = RX || []; if (L === 'de') RX = RX.concat([[/^(?:\uD83D\uDD25\s*)?Spare jetzt bis zu\s*\d+\s*%/, 'Spare jetzt bis zu 34 %']]);
  D['Einkaufstasche'] = HD; D['EINKAUFSTASCHE'] = HD.toUpperCase(); D['Shopping bag'] = HD; D['SHOPPING BAG'] = HD.toUpperCase();
  function tr(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      var p = n.parentElement; if (!p || p.tagName === 'STYLE' || p.tagName === 'SCRIPT') continue;
      var raw = n.textContent, s = raw.trim(); if (!s) continue;
      var out = D[s];
      if (out == null) { for (var i = 0; i < RX.length; i++) { if (RX[i][0].test(s)) { out = s.replace(RX[i][0], RX[i][1]); break; } } }
      if (out != null && out !== s) n.textContent = raw.replace(s, out);
    }
  }
  var seen = new WeakSet();
  function hook() {
    document.querySelectorAll('section-store--cart-block').forEach(function (h) {
      var r = h.shadowRoot; if (!r || seen.has(r)) return; seen.add(r);
      tr(r);
      var t = null;
      new MutationObserver(function () { tr(r); }).observe(r, { childList: true, subtree: true, characterData: true });
    });
  }
  hook(); setInterval(hook, 1500); var hk0 = 0; (function hf() { hook(); if (hk0++ < 300) requestAnimationFrame(hf); })();
})();

/* ---------- NOTE23 Seiten-Übersetzung für Gravur-/Namensfelder (sv/fi) ---------- */
(function () {
  if (window.__n23pageTr) return; window.__n23pageTr = true;
  var L = String((window.Shopify && Shopify.locale) || document.documentElement.lang || 'de').toLowerCase().slice(0, 2);
  var S = {
    'Gravur Rückseite (nur bei „Ja“)': ['Gravyr baksida (endast vid ”Ja”)', 'Kaiverrus takapuolelle (vain jos ”Kyllä”)'],
    'Botschaft Rückseite (nur bei „Ja“)': ['Meddelande baksida (endast vid ”Ja”)', 'Viesti takapuolelle (vain jos ”Kyllä”)'],
    'Geburtsmonate der Steine': ['Stenarnas födelsemånader', 'Kivien syntymäkuukaudet'],
    'Wunsch-Anhänger': ['Önskade berlocker', 'Toivotut riipukset'],
    'Wunsch-Glücksbringer': ['Önskade lyckoberlocker', 'Toivotut onnenamuletit'],
    'Wunsch-Symbol (optional)': ['Önskad symbol (valfritt)', 'Toivottu symboli (valinnainen)'],
    'z. B. Für immer': ['t.ex. För alltid', 'esim. Ikuisesti'],
    'z. B. März, Juli': ['t.ex. mars, juli', 'esim. maaliskuu, heinäkuu'],
    'z. B. Schloss, Kristallherz': ['t.ex. lås, kristallhjärta', 'esim. lukko, kristallisydän'],
    'z. B. Kleeblatt, Herz': ['t.ex. klöverblad, hjärta', 'esim. apila, sydän'],
    'z. B. Ich liebe dich': ['t.ex. Jag älskar dig', 'esim. Rakastan sinua'],
    'z. B. Herz': ['t.ex. hjärta', 'esim. sydän'],
    'z. B. Für Papa': ['t.ex. Till pappa', 'esim. Isälle'],
    'Anzahl der Namen': ['Antal namn', 'Nimien määrä'],
    '1 Name – inklusive': ['1 namn – ingår', '1 nimi – sisältyy'],
    'Schriftart auswählen:': ['Välj typsnitt:', 'Valitse fontti:'],
    'Schriftart': ['Typsnitt', 'Fontti'],
    'Klassisch': ['Klassisk', 'Klassinen'],
    'Modern': ['Modern', 'Moderni'],
    'Schrift': ['Skrivstil', 'Käsiala'],
    'Live-Vorschau': ['Liveförhandsvisning', 'Live-esikatselu'],
    'Vorschau deiner Gravur': ['Förhandsvisning av din gravyr', 'Kaiverruksesi esikatselu'],
    'Namen eingeben': ['Skriv in namn', 'Syötä nimet'],
    '✍️ Graviert wird genau so, wie du es eingibst. 📦 Lieferzeit: 4–6 Werktage.': ['✍️ Vi graverar exakt det du skriver in. 📦 Leveranstid: 4–6 arbetsdagar.', '✍️ Kaiverramme juuri sen, mitä kirjoitat. 📦 Toimitusaika: 4–6 arkipäivää.'],
    '✍️ Von uns graviert · 📦 Lieferzeit: 4–6 Werktage inkl. Gravur.': ['✍️ Graverad av oss · 📦 Leveranstid: 4–6 arbetsdagar inkl. gravyr.', '✍️ Me kaiverramme · 📦 Toimitusaika: 4–6 arkipäivää kaiverrus mukaan lukien.'],
    'Bitte prüf die Schreibweise – graviert wird genau so, wie du es eingibst.': ['Kontrollera stavningen – vi graverar exakt det du skriver in.', 'Tarkista kirjoitusasu – kaiverramme juuri sen, mitä kirjoitat.'],
    'Welche Länge passt?': ['Vilken längd passar?', 'Mikä pituus sopii?'],
    'Größenhinweis': ['Storleksguide', 'Kokotaulukko'],
    'Schließen': ['Stäng', 'Sulje'],
    'Deine Gravur': ['Din gravyr', 'Kaiverruksesi'],
    'Name': ['Namn', 'Nimi'],
    'Gravur (optional)': ['Gravyr (valfritt)', 'Kaiverrus (valinnainen)'],
    'Datum': ['Datum', 'Päivämäärä'],
    'Zeile 1': ['Rad 1', 'Rivi 1'],
    'Zeile 2': ['Rad 2', 'Rivi 2'],
    'Initiale': ['Initial', 'Nimikirjain'],
    'Gravur Vorderseite': ['Gravyr framsida', 'Kaiverrus etupuolelle'],
    'Seite 1': ['Sida 1', 'Puoli 1'], 'Seite 2': ['Sida 2', 'Puoli 2'], 'Seite 3': ['Sida 3', 'Puoli 3'],
    'Seite 4 (nur 4–6)': ['Sida 4 (endast 4–6)', 'Puoli 4 (vain 4–6)'], 'Seite 5 (nur 4–6)': ['Sida 5 (endast 4–6)', 'Puoli 5 (vain 4–6)'], 'Seite 6 (nur 4–6)': ['Sida 6 (endast 4–6)', 'Puoli 6 (vain 4–6)'],
    'Gravur außen': ['Gravyr utsida', 'Kaiverrus ulkopuolelle'],
    'Gravur innen (nur bei Außen + Innen)': ['Gravyr insida (endast vid utsida + insida)', 'Kaiverrus sisäpuolelle (vain ulko- + sisäpuoli)'],
    'Geburtsdatum': ['Födelsedatum', 'Syntymäpäivä'],
    'Gewicht': ['Vikt', 'Paino'],
    'Größe': ['Längd', 'Pituus'],
    'Uhrzeit': ['Klockslag', 'Kellonaika'],
    'TT.MM.JJJJ': ['DD.MM.ÅÅÅÅ', 'PP.KK.VVVV'],
    'z. B. Für Papa': ['t.ex. För pappa', 'esim. Isälle'],
    'z. B. Folge deinem Weg': ['t.ex. Följ din väg', 'esim. Seuraa polkuasi'],
    'z. B. Für immer': ['t.ex. För alltid', 'esim. Ikuisesti'],
    'z. B. Glaub an dich': ['t.ex. Tro på dig själv', 'esim. Usko itseesi'],
    'z. B. 3.450 g': ['t.ex. 3 450 g', 'esim. 3 450 g'],
    'Alle ansehen →': ['Visa alla →', 'Näytä kaikki →'],
    'ab': ['från', 'alkaen']
  };
  var R = [
    [/^(\d+) Namen – je \+(.+)$/, ['$1 namn – +$2 per namn', '$1 nimeä – +$2 / nimi']],
    [/^(\d+)\. Name$/, ['$1. namn', '$1. nimi']],
    [/^Name (\d+)$/, ['Namn $1', 'Nimi $1']],
    [/^Datum (\d+)$/, ['Datum $1', 'Päivämäärä $1']],
    [/^(\d+) Modelle →$/, ['$1 modeller →', '$1 mallia →']],
    [/^z\. B\. (.+)$/, ['t.ex. $1', 'esim. $1']]
  ];
  var li = L === 'sv' ? 0 : L === 'fi' ? 1 : -1;
  if (li < 0) return;
  function t1(s) {
    var k = s.trim(); if (!k) return null; var mo = k.match(/^(.*\S)\s+\(optional\)$/); if (mo && !S[k]) { var inner = t1(mo[1]); return s.replace(k, (inner !== null ? inner.trim() : mo[1]) + (li === 0 ? ' (valfritt)' : ' (valinnainen)')); }
    var hit = S[k]; if (hit) return s.replace(k, hit[li]);
    for (var i = 0; i < R.length; i++) if (R[i][0].test(k)) return s.replace(k, k.replace(R[i][0], R[i][1][li]));
    return null;
  }
  function run(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT), n, out;
    while ((n = w.nextNode())) {
      var p = n.parentElement; if (!p || /^(STYLE|SCRIPT|NOSCRIPT|TEXTAREA)$/.test(p.tagName)) continue;
      out = t1(n.textContent); if (out != null && out !== n.textContent) n.textContent = out;
    }
    (root.querySelectorAll ? root : document).querySelectorAll('[placeholder],[aria-label],[title]').forEach(function (e) {
      ['placeholder', 'aria-label', 'title'].forEach(function (a) { var v = e.getAttribute(a); if (!v) return; var o = t1(v); if (o != null && o !== v) e.setAttribute(a, o); });
    });
  }
  var tm = null;
  function sched() { clearTimeout(tm); tm = setTimeout(function () { run(document.body); }, 60); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(document.body); }); else run(document.body);
  new MutationObserver(function (m) { for (var i = 0; i < m.length; i++) { if (m[i].type === 'childList' && m[i].addedNodes.length) { sched(); return; } } }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ---------- N23 Gravur bearbeiten (prefill + replace old cart line) ---------- */
(function () {
  if (window.__n23edit) return; window.__n23edit = true;
  var SK = 'n23editKey';
  function get() { try { var v = JSON.parse(sessionStorage.getItem(SK) || 'null'); if (v && Date.now() - v.t < 3600000) return v; } catch (e) {} return null; }
  function put(v) { try { if (v) sessionStorage.setItem(SK, JSON.stringify(v)); else sessionStorage.removeItem(SK); } catch (e) {} }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var q; try { q = new URLSearchParams(location.search); } catch (e) { q = null; }
  if (q && q.get('n23e') && q.get('n23k')) {
    put({ k: q.get('n23k'), p: location.pathname, t: Date.now() });
    var list = q.get('n23e').split('|'), font = q.get('n23f'), tries = 0;
    var fill = function () {
      var ins = document.querySelectorAll('input[name^="properties[Name "]');
      if (ins.length < list.length && tries++ < 50) { setTimeout(fill, 150); return; }
      if (font === 'modern' || font === 'klassisch') { var b = document.querySelector('[data-n23n-font="' + font + '"]'); if (b) b.click(); }
      ins.forEach(function (inp, i) { if (list[i] != null) { inp.value = list[i]; inp.dispatchEvent(new Event('input', { bubbles: true })); inp.dispatchEvent(new Event('change', { bubbles: true })); } });
      var blk = document.querySelector('.n23n__names') || document.querySelector('.n23n');
      if (blk && blk.scrollIntoView) blk.scrollIntoView({ block: 'center' });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fill); else fill();
    try { var vv = q.get('variant'); history.replaceState(history.state, '', location.pathname + (vv ? '?variant=' + vv : '')); } catch (e) {}
  }
  var _f = window.fetch.bind(window);
  window.fetch = function (input) {
    var a = arguments, u = typeof input === 'string' ? input : (input && input.url) || '';
    var e = /\/cart\/add/.test(u) ? get() : null;
    if (e && e.p === location.pathname) {
      put(null);
      return _f(root + 'cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: e.k, quantity: 0 }) })
        .catch(function () {}).then(function () { return _f.apply(window, a); });
    }
    return _f.apply(window, a);
  };
})();

/* ---------- N23 localized gallery images (non-DE) ---------- */
(function () {
  if (window.__n23imgSwap) return; window.__n23imgSwap = true;
  var L = String((window.Shopify && Shopify.locale) || document.documentElement.lang || 'de').toLowerCase().slice(0, 2);
  if (L === 'de') return;
  var MAP = [['note23-anker-papa-armband-dark.png', 'note23-anker-dad-bracelet-en.png', '1791807925']];
  function fix() {
    MAP.forEach(function (m) {
      var sel = 'img[src*="' + m[0] + '"],img[srcset*="' + m[0] + '"],source[srcset*="' + m[0] + '"],img[data-src*="' + m[0] + '"]';
      document.querySelectorAll(sel).forEach(function (el) {
        ['src', 'srcset', 'data-src', 'data-srcset'].forEach(function (a) {
          var v = el.getAttribute(a);
          if (v && v.indexOf(m[0]) > -1) el.setAttribute(a, v.split(m[0]).join(m[1]).replace(/([?&])v=\d+/g, '$1v=' + m[2]));
        });
        if (el.alt && /papa/i.test(el.alt)) el.alt = 'NOTE23 Anker – The Dad Bracelet';
      });
    });
  }
  fix();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fix);
  new MutationObserver(fix).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset'] });
})();
